export const UserAtcuEnum = {
    ATCU1: 'ATCU1',
    ATCU2: 'ATCU2',
    NONE: 'NEMA'
};
